var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.240361 0.153094C0.341723 0.0713905 0.466113 0.0197702 0.598087 0.00464239C0.730061 -0.0104854 0.863805 0.0115455 0.982714 0.0679999L18.6255 8.44849C18.738 8.50208 18.8327 8.58438 18.8988 8.68616C18.965 8.78794 19 8.90519 19 9.02481C19 9.14442 18.965 9.26168 18.8988 9.36346C18.8327 9.46524 18.738 9.54753 18.6255 9.60113L0.982714 17.9816C0.863886 18.0382 0.730174 18.0604 0.598182 18.0455C0.466189 18.0305 0.341728 17.979 0.240252 17.8975C0.138776 17.8159 0.0647544 17.7078 0.0273772 17.5866C-0.00999996 17.4654 -0.00908637 17.3365 0.0300048 17.2158L2.6832 9.02481L0.0300048 0.833848C-0.0088628 0.713268 -0.0096504 0.584507 0.0277393 0.463506C0.065129 0.342506 0.139054 0.234581 0.240361 0.153094ZM3.89377 9.66946L1.79428 16.1547L16.8042 9.02481L1.79428 1.89495L3.89377 8.38016H11.5358C11.7158 8.38016 11.8884 8.44807 12.0156 8.56897C12.1429 8.68987 12.2144 8.85384 12.2144 9.02481C12.2144 9.19578 12.1429 9.35975 12.0156 9.48065C11.8884 9.60154 11.7158 9.66946 11.5358 9.66946H3.89377Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.fcc1aed8b5b44ded1527162293af9676.svg";
export { ForwardRef as ReactComponent };